import { render, staticRenderFns } from "./yun_yz.vue?vue&type=template&id=0888a38b&scoped=true&"
import script from "./yun_yz.vue?vue&type=script&lang=js&"
export * from "./yun_yz.vue?vue&type=script&lang=js&"
import style0 from "./yun_yz.vue?vue&type=style&index=0&id=0888a38b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0888a38b",
  null
  
)

export default component.exports